import { render, staticRenderFns } from "./ConfigureGroup.vue?vue&type=template&id=2ff02489&scoped=true&"
import script from "./ConfigureGroup.vue?vue&type=script&lang=js&"
export * from "./ConfigureGroup.vue?vue&type=script&lang=js&"
import style0 from "./ConfigureGroup.vue?vue&type=style&index=0&id=2ff02489&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff02489",
  null
  
)

export default component.exports